import { ImageSourcePropType } from 'react-native';

import { ServiceMode } from './types';

export const SERVICE_MODE_ORDER: ServiceMode[] = [
  ServiceMode.TAKEOUT,
  ServiceMode.DRIVE_THRU,
  ServiceMode.MOBILE_ORDER_DRIVE_THRU,
  ServiceMode.EAT_IN,
];

export const serviceModeImages: Partial<Record<ServiceMode, ImageSourcePropType>> = {
  [ServiceMode.DRIVE_THRU]: require('src/pages/cart/details/images/drive-thru.jpg'),
  [ServiceMode.MOBILE_ORDER_DRIVE_THRU]: require('src/pages/cart/details/images/drive-thru.jpg'),
  [ServiceMode.TAKEOUT]: require('src/pages/cart/details/images/take-out.jpg'),
  [ServiceMode.EAT_IN]: require('src/pages/cart/details/images/dine-in.jpg'),
};
